import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'currency',
  templateUrl: './currency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, CurrencyformatPipe],
})
export class CurrencyComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() keyName = new BehaviorSubject(null);
  @Input() isClickable = new BehaviorSubject(false);
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }

  constructor() {}
  ngOnInit(): void {}
  openWriteOffModal(action: string, columnData: any) {
    this.onAction.emit({ action, columnData: columnData });
  }
}
